/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-17 17:18:53
 * @LastEditors: susj
 * @LastEditTime: 2020-11-26 14:23:30
 */
// initial state
import Work from '../../components/core/models/work';
import { actions as pageActions, mutations as pageMutations } from './page';
import { actions as elementActions, mutations as elementMutations } from './element';
import { actions as workActions, mutations as workMutations } from './work';

const state = {
  works: [],
  work: new Work(),
  canUndo: false,
  canRedo: false,
  isPreviewMode: false, // 是否预览模式
  editingPageIndex: 0,
  editingPage: { elements: [] },
  editingElement: null,
  previewSaveElement: [],
  formDetailOfWork: {
    uuidMap2Name: {},
    formRecords: [],
  },
  workTemplates: [],
  hasSelectText: false,
  sentenceCategory: [],
  sentenceList: [],
};

// getters
const getters = {
  pagesRoomIndexList(state) {
    return state.work.pages
      .map((item, index) => (item.slideType === 1 ? index : null))
      .filter(n => n !== null);
  },

};

// actions
const actions = {
  ...elementActions,
  ...pageActions,
  ...workActions,
};

// mutations
const mutations = {
  setHasSelectText(state, payload) {
    state.hasSelectText = payload;
  },
  setCanUndo(state, payload) {
    state.canUndo = payload;
  },
  setCanRedo(state, payload) {
    state.canRedo = payload;
  },
  ...elementMutations,
  ...pageMutations,
  ...workMutations,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
